export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    slug: 'maid-cafe-culture',
    name: '女仆咖啡厅文化',
    description: '从秋叶原到全球，女仆咖啡厅如何成为一种独特的文化现象，探讨其历史演变与社会影响。',
    icon: 'ri-cup-line',
    imageSeq: 'cat-maid-cafe',
  },
  {
    slug: 'role-identity',
    name: '女仆角色认同',
    description: '穿上女仆装的那一刻，不只是扮演，更是身份的重塑。深入探索女仆角色认同的心理与文化维度。',
    icon: 'ri-user-heart-line',
    imageSeq: 'cat-role-identity',
  },
  {
    slug: 'maid-lifestyle',
    name: '女仆生活方式',
    description: '女仆文化如何融入日常生活？从服饰、礼仪到社群，解读女仆作为一种生活方式的独特魅力。',
    icon: 'ri-home-heart-line',
    imageSeq: 'cat-maid-lifestyle',
  },
  {
    slug: 'anime-maid-culture',
    name: '二次元女仆文化',
    description: '从动漫到游戏，女仆形象在二次元世界中的演变与影响，以及粉丝文化如何推动这一形象的发展。',
    icon: 'ri-movie-2-line',
    imageSeq: 'cat-anime-maid',
  },
  {
    slug: 'real-experience',
    name: '女仆职业真实体验',
    description: '真实女仆从业者的故事与心声，揭开女仆职业的神秘面纱，展现工作中的欢笑与挑战。',
    icon: 'ri-chat-smile-2-line',
    imageSeq: 'cat-real-experience',
  },
  {
    slug: 'emotional-connection',
    name: '女仆情感连接',
    description: '女仆与顾客之间超越服务的情感纽带——温暖、治愈与陪伴，探索女仆文化中独特的情感连接。',
    icon: 'ri-heart-pulse-line',
    imageSeq: 'cat-emotional',
  },
];